// extracted by mini-css-extract-plugin
export default {"cardFooter":"CardFooter_cardFooter__aZaXs","likesDislikes":"CardFooter_likesDislikes__my4Np","bookmarks":"CardFooter_bookmarks__9LIkL"};